import { createImage } from "./utils";

const MAX_DIMENSION = 1600;
const JPEG_QUALITY = 0.82;

async function getCroppedImg(imageSrc, pixelCrop, { maxDimension = MAX_DIMENSION, quality = JPEG_QUALITY } = {}) {
	const image = await createImage(imageSrc);
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");

	let outputWidth = pixelCrop.width;
	let outputHeight = pixelCrop.height;

	const largestSide = Math.max(outputWidth, outputHeight);
	if (largestSide > maxDimension) {
		const scale = maxDimension / largestSide;
		outputWidth = Math.round(outputWidth * scale);
		outputHeight = Math.round(outputHeight * scale);
	}

	canvas.width = outputWidth;
	canvas.height = outputHeight;

	ctx.drawImage(
		image,
		pixelCrop.x,
		pixelCrop.y,
		pixelCrop.width,
		pixelCrop.height,
		0,
		0,
		outputWidth,
		outputHeight
	);

	return new Promise((resolve, reject) => {
		canvas.toBlob(
			(blob) => (blob ? resolve(blob) : reject(new Error("Failed to process image"))),
			"image/jpeg",
			quality
		);
	});
}

export default getCroppedImg;
